import { Dispatch, Action } from 'redux'
import { TaskSizeSelectFieldMapDispatchReturnType } from './types/TaskSizeSelectFieldMapDispatchReturnType'

export const TaskSizeSelectFieldMapDispatch = (
  _dispatch: Dispatch<Action>
): TaskSizeSelectFieldMapDispatchReturnType => {
  return {}
}
